module.exports = __webpack_public_path__ + "img/poster_native-steps.60e19ee0.png";